import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import UIOverlayProvider from "./components/UIOverlayProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <UIOverlayProvider>
      <App />
    </UIOverlayProvider>
  </BrowserRouter>
);
